"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviourDay = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const structural_organisms_1 = require("../structural-organisms");
const CollapseBehaviourDay_1 = __importDefault(require("./CollapseBehaviourDay"));
const react_i18next_1 = require("react-i18next");
const error_1 = require("../../atoms/error");
const BehaviourDay = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.day.lessonTitle ? ((0, jsx_runtime_1.jsx)(structural_organisms_1.ListWithMargin, { children: [
                (0, jsx_runtime_1.jsx)(CollapseBehaviourDay_1.default, { title: t("behavior.day.challengeAnswer"), bodyValue: props.day.memberAnswer.content || "", img: props.day.memberAnswer.imageUrl, isAnswer: true }, "answer"),
                (0, jsx_runtime_1.jsx)(CollapseBehaviourDay_1.default, { title: props.day.lessonTitle, bodyValue: props.day.lessonDescription }, "lesson")
            ] }, void 0)) : ((0, jsx_runtime_1.jsx)(error_1.Error, { message: t("behavior.day.noLesson") }, void 0)) }, void 0));
};
exports.BehaviourDay = BehaviourDay;
//# sourceMappingURL=BehaviourDay.js.map